import { getJson } from "./client";

/** Wire shape returned by `QuotesController` — `ProvidedQuote[]` from the worker. */
export interface QuoteRow {
	provider: string;
	assetId: string;
	expectedNetApy: string;
	pricePerUnitUsdc: string;
	exitTimeDays: number;
	maturity: string | null;
	costBpsIn: number;
	costBpsOut: number;
	observedAt: string;
}

/** The worker returns a bare array; type the call site accordingly. */
export function fetchQuotes(): Promise<QuoteRow[]> {
	return getJson<QuoteRow[]>("/quotes");
}
